import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MaterialModule } from '@ukam/ui-kit/material.module';
import { AppSearchInputComponent, AppSearchPaginationComponent, AppSearchTitleComponent } from '@ukam/ui-kit/searchs';
import { AppFeatureFilterComponent } from '@ukam/filters/components/feature-filter/feature-filter.component';
import { FilterBaseService } from '@ukam/filters/services/filter-base.service';
import { formatBytes } from '@ukam/core/functions/bytes.functions';
import { StoredFile } from '@ukam/core/storages/models/stored-file';
import { StoredFileFinderSearchService } from '../services/stored-file-finder-search.service';
import { StoredFileFinderService } from '../services/stored-file-finder.service';
import { StoredFileFinderFilterService } from '../services/stored-file-finder-filter.service';

@Component({
  selector: 'app-stored-file-finder-list',
  templateUrl: './list.component.html',
  providers: [{ provide: FilterBaseService, useExisting: StoredFileFinderFilterService }],
  imports: [
    AppFeatureFilterComponent,
    MaterialModule,
    NgScrollbarModule,
    CommonModule,
    TranslocoModule,
    FormsModule,
    RouterModule,
    AppSearchInputComponent,
    AppSearchPaginationComponent,
    AppSearchTitleComponent,
  ],
})
export class AppStoredFileFinderListComponent {
  service = inject(StoredFileFinderService);
  searchService = inject(StoredFileFinderSearchService);
  sidePanelOpened = signal(true);

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  formatBytes = formatBytes;

  isOver(): boolean {
    return window.innerWidth < 1199;
  }

  /** Mesmo ícone por MIME usado no explorador de arquivos. */
  iconOf(file: StoredFile): string {
    const mime = file.contentType ?? '';
    if (mime.startsWith('image/')) return 'solar:gallery-bold';
    if (mime.startsWith('video/')) return 'solar:videocamera-record-bold';
    if (mime.startsWith('audio/')) return 'solar:music-note-2-bold';
    if (mime === 'application/pdf') return 'solar:document-text-bold';
    if (mime.includes('spreadsheet') || mime.includes('excel') || mime === 'text/csv') return 'solar:chart-square-bold';
    if (mime.includes('presentation') || mime.includes('powerpoint')) return 'solar:presentation-graph-bold';
    if (mime.includes('word')) return 'solar:document-bold';
    if (mime.includes('zip') || mime.includes('compressed') || mime.includes('tar')) return 'solar:zip-file-bold';
    if (mime.startsWith('text/') || mime.includes('json') || mime.includes('xml')) return 'solar:code-file-bold';
    return 'solar:file-bold';
  }

  /** Abre o explorador de arquivos (tela Files). */
  navigateFiles(): void {
    this.router.navigate(['/files']);
  }

  selectItem(item: StoredFile): void {
    this.router.navigate([item.id], { relativeTo: this.route });
  }

  download(item: StoredFile, event: Event): void {
    event.stopPropagation();
    this.service.download(item);
  }
}
